import React from "react";
import { Tooltip, IconButton } from "@mui/joy";
import { Switch } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import styles from "./phoneinbound.module.css";

const pad = (n : number) => (n < 10 ? "0" + n : String(n));

export const formatDuration = (sec : number) => {
    const s = Math.max(0, Math.floor(sec));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    return h > 0 ? `${h}:${pad(m)}:${pad(r)}` : `${pad(m)}:${pad(r)}`;
};

//수신자 한 줄: 이름 / 상태 뱃지 / (본사팀) ★담당 토글 · (지점 폰) 담당 모드 pill / 수신 토글 / 상세
const ReceiverRow : React.FC<any> = (props) => {

    const r = props.receiver;
    const enabled = r.enabled === 1 || r.enabled === true;
    const isManager = r.isManager === 1 || r.isManager === true;
    const isBranch = r.receiverType === "branch";
    //서버가 준 busySeconds에 수신 후 경과 시간을 더해서 로컬 카운트업 (클라이언트 시계 차이 영향 없음)
    const busySeconds = (r.busySeconds || 0) + Math.floor((props.now - (r._receivedAt || props.now)) / 1000);

    const renderStatus = () => {
        if (!enabled) {
            return <span className={styles.statusNone}>—</span>;
        }
        if (!props.pbxConnected) {
            return <span className={styles.statusNone} title="교환기 미연결">—</span>;
        }
        switch (r.liveStatus) {
            case "available":
                return <span className={`${styles.statusBadge} ${styles.statusAvailable}`}><span className={styles.dot} />대기{isBranch && props.managerMode !== "branch" ? <span className={styles.statusNote}>(전체 큐)</span> : ""}</span>;
            case "busy":
                return <span className={`${styles.statusBadge} ${styles.statusBusy}`}><span className={styles.dot} />통화중 {formatDuration(busySeconds)}</span>;
            case "offline":
                return <span className={`${styles.statusBadge} ${styles.statusOffline}`}><span className={styles.dot} />폰 꺼짐</span>;
            case "paused":
                return <span className={`${styles.statusBadge} ${styles.statusPaused}`}><span className={styles.dot} />수신 안 함</span>;
            default:
                return <span className={styles.statusNone}>—</span>;
        }
    };

    //4열: 본사팀 → ★담당 토글 뱃지, 지점 폰 → 담당 모드 pill (행에서 바로 전환)
    const renderRole = () => {
        if (!isBranch) {
            return (
                <button
                    type="button"
                    className={`${styles.managerBadge} ${isManager ? styles.managerBadgeOn : styles.managerBadgeOff}`}
                    disabled={props.busy}
                    onClick={() => props.onManager(!isManager)}
                    title={isManager ? "담당 해제 (담당자 큐에서 제거)" : "담당 지정 (담당자 큐에 등록)"}
                >
                    {isManager ? "★ 담당" : "담당"}
                </button>
            );
        }
        if (props.pairQueueExists === false) {
            return <span className={`${styles.modePill} ${styles.modePillDisabled}`} title="담당자 큐가 교환기에 없습니다">⚠ 담당자 큐 없음 · 설정 불가</span>;
        }
        if (props.managerMode === "branch") {
            return (
                <button type="button" className={`${styles.modePill} ${styles.modePillBranch}`} disabled={props.busy} onClick={() => props.onModeToggle("hq")} title="클릭하면 본사 담당 모드로 전환">
                    ★ 지점 직접 수신
                </button>
            );
        }
        return (
            <button type="button" className={`${styles.modePill} ${styles.modePillHq}`} disabled={props.busy} onClick={() => props.onModeToggle("branch")} title="클릭하면 지점 직접 수신으로 전환">
                본사 담당 모드
            </button>
        );
    };

    const rowClass = [
        styles.row,
        !enabled ? styles.rowOff : "",
        !isBranch && isManager && enabled ? styles.rowManager : "",
        isBranch && props.managerMode === "branch" && enabled ? styles.rowManager : ""
    ].join(" ");

    return (
        <div data-flip-id={String(r.id)} className={rowClass}>
            <div className={styles.nameCol}>
                <span className={styles.name}>{r.name}</span>
                {
                    isBranch ?
                        <span className={styles.sub}>· {props.queueName || r.branchQueue} 큐</span>
                        :
                        ""
                }
                <span className={styles.ext}>{r.extension}</span>
                {
                    isBranch && props.managerMode === "branch" && !enabled ?
                        <span className={styles.subWarn}>수신 꺼짐 — 담당 벨 없음</span>
                        :
                        ""
                }
                {
                    r.desynced ?
                        <Tooltip title={`교환기 설정과 다릅니다: ${(r.desyncReasons || []).join(" / ")}`} variant="soft" color="warning">
                            <WarningAmberRoundedIcon className={styles.desyncIcon} />
                        </Tooltip>
                        :
                        ""
                }
            </div>
            <div className={styles.statusCol}>
                {renderStatus()}
            </div>
            <div className={styles.roleCol}>
                {renderRole()}
            </div>
            <div>
                <Switch
                    size="small"
                    checked={enabled}
                    disabled={props.busy}
                    onChange={(e) => props.onToggle(e.target.checked)}
                />
            </div>
            <div>
                <IconButton size="sm" variant="plain" color="neutral" onClick={props.onOpenDetail}>
                    <MoreHorizIcon />
                </IconButton>
            </div>
        </div>
    );
};

export default ReceiverRow;
